import { AxiosInstance, AxiosRequestConfig } from "axios"

export interface SaveLocationRequest extends Partial<AxiosRequestConfig> {
  params: {
    name: string
    place_id: string
    url: string
  }
}

export const registerIndexedPageInfoApi = (
  { params, method = "get", ...config }: SaveLocationRequest,
  axiosInstance: AxiosInstance,
) => {
  const url = `/search/save-location/${params.place_id}/${params.url}?name=${params.name}`
  return axiosInstance({
    method,
    url,
    ...config,
  })
}
